import Mmenu from 'mmenu-js'

export function initMmenu() {
  const mmenuEl = document.getElementById('mmenu')

  if (!mmenuEl) {
    return
  }

  const mmenuSocials = document
    .querySelector('[data-mmenu-socials]')
    .content.cloneNode(true)
  const extensions = [
    'theme-light',
    'pagedim-black',
    'shadow-panels',
    'effect-slide-menu',
  ]

  if (document.documentElement.dir !== 'rtl') {
    extensions.push('position-right')
  }

  new Mmenu(
    '#mmenu',
    {
      extensions,
      navbars: [
        {
          title: mmenuEl.dataset.title,
        },
        {
          position: 'bottom',
          content: [mmenuSocials],
        },
      ],
    },
    {
      offCanvas: {
        page: {
          selector: '.js-layout',
        },
      },
    }
  )
}
